module.exports = __webpack_public_path__ + "static/img/step2.61c88c35.jpg";